module.exports = __webpack_public_path__ + "static/media/exit.8c53b830.png";